import React, { forwardRef, useImperativeHandle } from "react";
import ReactDOM from "react-dom";
import ModalSpecial from "../../../Layout/Modals/ModalSpecial";
import OrderShowModal from "./orderShowModal";
import { getStatusesOptions } from "../../../../redux/Actions/statusesAction";
import { getSuppliersOption } from "../../../../redux/Actions/supplierAction";
import { getCommentStateOption } from "../../../../redux/Actions/comment_StateAction";
import { addOverFlow, removeOverFlow } from "../../../../helpers/modalFunc";
import ServiceModalComponent from "../../../ServicePage/Items/ServiceForms/ServiceModalComponent";
import { useSelector } from "react-redux";
import Spinner from "../../Spinner";
import { CommentStateType } from "../../CommentState_type";
import FakeOrderShowModal from "../../../fake_orders/FakeOrderShowModal";
import { Alert } from "../../../globals";

const RegularOrderChildren = forwardRef((props, ref) => {
  const { loading_order, error_order } = useSelector((state) => state.orders);
  const validate_comments = useSelector(
    (state) => state.orders.validate_comments
  );
  const [display, setDisplay] = React.useState("first");
  const [SupplySupplierData, setSupplySupplierData] = React.useState([]);
  const [CommentsState, setCommentsState] = React.useState([]);
  const [AvailableStatus, setAvailableStatus] = React.useState([]);
  useImperativeHandle(ref, () => {
    return {
      openModal: (active) => open(active),
      close: () => close(),
      active: display,
    };
  });

  const open = (active) => {
    if (active !== "Service") {
      requestOfOptions();
    }
    addOverFlow();
    setDisplay(active);
  };

  const close = () => {
    removeOverFlow();
    setDisplay(false);
  };

  const requestOfOptions = () => {
    getSuppliersOption().then((response) => {
      if (response.data) {
        let newArray = [];
        response.data.data.forEach((item) => {
          const findIndex = newArray.findIndex(
            (find) => find.name == item.name
          );
          if (findIndex == -1) {
            return newArray.push({
              value: item.id,
              name: item.name,
              code: item.code,
              label: item.title || item.name,
              is_code: item.is_code,
            });
          }
        });
        setSupplySupplierData(newArray);
      }
    });

    getCommentStateOption().then((res) => {
      if (res.data) {
        let commentAll = [];
        let comment_ka = [];
        let comment_management = [];
        let comment_logistic = [];

        res.data.forEach((item) => {
          let newObj = {
            label: item.name,
            name: item.name,
            value: item.id,
            color: item.color,
            ordering: item.ordering,
            identifier: item.identifier,
            comment_type: item.comment_type,
            show_date: item.show_date,
          };
          commentAll.push(newObj);
          let cmst = item.comment_type;
          if (cmst == "comment_ka") {
            comment_ka.push(item);
          } else if (cmst == "comment_management") {
            comment_management.push(item);
          } else {
            comment_logistic.push(item);
          }
        });
        setCommentsState(commentAll);
      }
    });

    getStatusesOptions().then((response) => {
      if (response) {
        setAvailableStatus(response);
      }
    });

    console.count("Request times; ");
  };

  if (display == "FakeOrderShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Fake order <span className="text-orange">#</span>
        FO{props.requiredOrderId}
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => {}}
        onClose={() => {
          close();
        }}
      >
        {loading_order ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <Spinner />
          </div>
        ) : !!error_order ? (
          <Alert message={error_order} type="error" />
        ) : (
          <FakeOrderShowModal order_id={props.requiredOrderId} />
        )}
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  } else if (display == "OrderShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Order <span className="text-orange">#</span>
        {props.requiredOrderId}
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => {}}
        onClose={() => {
          if (Object.values(validate_comments).some((d) => d)) {
            if (
              confirm(
                `Are you sure want to close modal with unposted comments ? Unposted: ${Object.entries(
                  validate_comments
                )
                  .filter((d) => d[1])
                  .map((d) => CommentStateType(d[0]))
                  .join(", ")}`
              )
            )
              return close();
          } else {
            close();
          }
        }}
      >
        {loading_order ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <Spinner />
          </div>
        ) : !!error_order ? (
          <Alert message={error_order} type="error" />
        ) : (
          <OrderShowModal
            modal_type={props.modal_type}
            avalaibleStatus={AvailableStatus}
            supplySupplier={SupplySupplierData}
            comments_state={CommentsState}
          />
        )}
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  } else if (display == "ServiceShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        <span className="text-black">RMA</span>{" "}
        <span className="text-orange">#</span>
        <span className="text-black">R{+props.requiredOrderId + 100}</span>
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => {}}
        onClose={() => close()}
      >
        <ServiceModalComponent id={props.requiredOrderId} />
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  }

  return null;
});

export default RegularOrderChildren;
